export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200" role="contentinfo">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-gradient-to-br from-primary-400 to-accent-400">
                <i className="ri-sound-module-line text-background-50 text-lg" />
              </div>
              <span className="font-heading text-xl font-bold text-background-50">Áudio Cura</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              Transformando vidas através do poder da cura sonora. Áudios com frequências
              cuidadosamente selecionadas para elevar sua vibração e trazer mais paz,
              amor e prosperidade.
            </p>
          </div>
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              Links Úteis
            </h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-background-400 cursor-default whitespace-nowrap">
                Política de Privacidade
              </span>
              <span className="text-sm text-background-400 cursor-default whitespace-nowrap">
                Termos de Uso
              </span>
              <span className="text-sm text-background-400 cursor-default whitespace-nowrap">
                Garantia de 7 Dias
              </span>
            </div>
          </div>
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              Redes Sociais
            </h4>
            <div className="flex gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-500 hover:text-background-50 transition-all cursor-pointer">
                <i className="ri-instagram-line" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-500 hover:text-background-50 transition-all cursor-pointer">
                <i className="ri-facebook-line" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-500 hover:text-background-50 transition-all cursor-pointer">
                <i className="ri-youtube-line" />
              </span>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            © 2026 Áudio Cura. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-3">
            <span className="text-xs text-background-600 flex items-center gap-1">
              <i className="ri-shield-check-line" />
              Pagamento 100% Seguro via Hotmart
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}